import { useAIChatbotAccess } from "@faire/help-center-self-serve/hooks/useAIChatbotAccess";
import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { useBrandMilestone } from "@faire/help-center-utils/src/hooks/useBrandMilestones";
import { useRetailerMilestone } from "@faire/help-center-utils/src/hooks/useRetailerMilestones";
import { DismissableTooltip } from "@faire/web--source/slate/Tooltip/DismissableTooltip";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { BRAND_DECAGON_AI_CHATBOT_TOOLTIP_SEEN } from "@faire/web-api--source/indigofair/data/IUserMilestone/BrandMilestone/BRAND_DECAGON_AI_CHATBOT_TOOLTIP_SEEN";
import { RETAILER_DECAGON_AI_CHATBOT_TOOLTIP_SEEN } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/RETAILER_DECAGON_AI_CHATBOT_TOOLTIP_SEEN";
import React from "react";
import styled from "styled-components";

export const ChatbotTooltip: React.FC = () => {
  const { hasAIChatbotAccess } = useAIChatbotAccess();
  const {
    hasOccurred: retailerChatbotTooltipHasOccurred,
    setHasOccurred: setRetailerChatbotTooltipOccurred,
    isLoading: retailerMilestoneIsLoading,
  } = useRetailerMilestone(RETAILER_DECAGON_AI_CHATBOT_TOOLTIP_SEEN);
  const {
    hasOccurred: brandChatbotTooltipHasOccurred,
    setHasOccurred: setBrandChatbotTooltipOccurred,
    isLoading: brandMilestoneIsLoading,
  } = useBrandMilestone(BRAND_DECAGON_AI_CHATBOT_TOOLTIP_SEEN);

  if (!hasAIChatbotAccess) {
    return null;
  }

  if (retailerMilestoneIsLoading || brandMilestoneIsLoading) {
    return null;
  }

  if (isRetailer() && retailerChatbotTooltipHasOccurred) {
    return null;
  }

  if (!isRetailer() && brandChatbotTooltipHasOccurred) {
    return null;
  }

  const handleDismiss = () => {
    if (isRetailer()) {
      setRetailerChatbotTooltipOccurred();
    } else {
      setBrandChatbotTooltipOccurred();
    }
  };

  return (
    <TooltipWrapper
      targetNode={<></>}
      position="top"
      pointerOffset={80}
      onDismiss={handleDismiss}
    >
      <Typography variant="paragraphSansMedium" color="inherit">
        <StrictLocalMsg
          defaultMessage="Try our new virtual assistant"
          description={{
            text: "Tooltip title for the chatbot",
          }}
        />
      </Typography>
      <Typography variant="paragraphSansRegular" color="inherit">
        <StrictLocalMsg
          defaultMessage="Ask our assistant about orders, returns, and more. It's here
        24/7—and can connect you to support specialists for more help."
          description={{
            text: "Tooltip description for the chatbot",
          }}
        />
      </Typography>
    </TooltipWrapper>
  );
};

const TooltipWrapper = styled(DismissableTooltip)`
  position: fixed;
  bottom: 78px;
  right: 108px;
`;
